import React from "react";
import {useFormik} from "formik";

import * as yup from "yup";
import {
    Autocomplete,
    Box,
    Button,
    CardActions,
    CardContent,
    createFilterOptions,
    FormControl, FormHelperText, InputLabel, MenuItem, Select,
    TextField
} from "@mui/material";
import {PersonApiGet} from "../people/people_api";
import {ProfileApiGet} from "./users_api";
import {Tables} from "../../apitypes";


interface ProfileFormProps {
    onSubmit: (values: ProfileApiGet) => void
    onCancel: () => void
    object: ProfileApiGet,
    isUpdating: boolean,
    workers: Tables<"worker">[]
}

const ProfileSchema = yup.object().shape({
    fullName: yup.string().required(),
})

export default ({object, workers, onSubmit, onCancel, isUpdating}: ProfileFormProps) => {

    const formik = useFormik<ProfileApiGet>({
        initialValues: object,
        onSubmit,
        validationSchema: ProfileSchema
    });

    // @ts-ignore
    return <Box component={"form"} className={"form-100"} onSubmit={formik.handleSubmit}>
        <CardContent>
            <TextField
                name={"fullName"}
                id={"fullName"}
                value={formik.values.fullName}
                label={"Ime za prikaz"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.fullName && Boolean(formik.errors.fullName)}
                helperText={formik.touched.fullName && formik.errors.fullName}
            />
            <Autocomplete
                id={"defaultWorker"}
                options={workers}
                autoSelect={true}
                value={formik.values.worker}
                getOptionLabel={(option: PersonApiGet) => {
                    return option.lastName + " " + option.firstName + " (" + option.partnerCode + ")";
                }}
                filterOptions={createFilterOptions({
                    stringify: (option) => option.lastName + " " + option.firstName + " " + option.partnerCode,
                })}
                onChange={(event, newValue) => {
                    formik.setFieldValue("worker", newValue);
                }}
                getOptionKey={(option) => option.documentID}
                renderInput={(params) => <TextField {...params} label="Privzeti delavec" />}
                renderOption={(props, option: PersonApiGet) => {
                    const {key,...rest} = props
                    return <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...rest} key={key}>
                        {option.lastName} {option.firstName} ({option.partnerCode})
                    </Box>
                }}
            />
            <FormControl fullWidth>
                <InputLabel id="roles-label">Vloga</InputLabel>
                <Select
                    labelId="roles-label"
                    id="['userRoles.roles']"
                    name={"['userRoles.roles']"}
                    value={formik.values.userRoles?.roles}
                    multiple={true}
                    label="Vloga"
                    onChange={(e) => formik.setFieldValue("userRoles.roles", e.target.value as string[] )}
                >
                    <MenuItem value={"Admin"}>Administrator</MenuItem>
                    <MenuItem value={"Foreman"}>Izmenovodja</MenuItem>
                    <MenuItem value={"Worker"}>Delavec</MenuItem>
                    <MenuItem value={"Analitics"}>Analitik</MenuItem>
                    <MenuItem value={"AllRegs"}>Vse odprte registracije</MenuItem>
                </Select>
                {/* @ts-ignore */}
                {Boolean(formik.errors.userRoles?.roles) && <FormHelperText>{formik.errors.userRoles?.roles}</FormHelperText>}
            </FormControl>
        </CardContent>
        <CardActions>
            <Button disabled={isUpdating} type={"submit"}>Shrani</Button>
            <Button onClick={onCancel}>Prekliči</Button>
        </CardActions>
    </Box>

}
